const _version = "2.15.5"
function version() {
    return _version
}
export default version
